import { Link } from 'react-router-dom';
import AnimeCard from '@/components/feature/AnimeCard';
import { featuredAnime } from '@/mocks/anime';

export default function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-1">
              精品动漫推荐
            </h2>
            <p className="text-sm text-foreground-500">高分好评，不容错过的精品动漫</p>
          </div>
          <Link
            to="/category/guochan"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4" data-product-shop="">
          {featuredAnime.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>
      </div>
    </section>
  );
}